import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router";

import AdIntegration from "./AdIntegration";
import AdsTxt from "./AdsTxt";
import AppAdsTxt from "./AppAdsTxt";
import AppAdIntegration from "./AppAdIntegration";

const Settings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const isApp = useSelector((state) => state.site?.selectedSite?.isApp);
  const integrationType = useSelector(
    (state) => state.auth?.user?.integrationType
  );

  useEffect(() => {
    if (isApp) {
      if (location.pathname !== "/settings/adstxt") {
        navigate("/settings/adstxt");
      }
    }
  }, [isApp, location, navigate]);

  if (isApp) {
    if (integrationType === 3 || integrationType === 4) {
      return <AppAdsTxt />;
    }
    return <AdsTxt />;
  }

  if (!isApp) {
    if (params.setting === "adstxt") {
      if (integrationType === 3 || integrationType === 4) {
        return <AppAdsTxt />;
      }
      return <AdsTxt />;
    }
    if (integrationType === 3 || integrationType === 4) {
      return <AppAdIntegration />;
    }
    return <AdIntegration />;
  }

  return null;
};

export default Settings;
